import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SET_CASINO_ID_STATUS, SET_CASINO_ID, SET_KYC_STATUS, SET_PROPERTY_NAME, SET_PROPERTY_ID, SET_SOUND_SETTINGS, IS_ACCOUNT_LINKED, SET_CURRENT_MEMBER_LEVEL, SET_IS_DEV_USER, SET_AFF_ID, SET_RATING_POPUP_TIME, SET_AD_BLOCKER_POPUP_TIME, SET_GAMES_OPENED_AMOUNT, SET_APPSFLYER_GAMES_OPENED_AMOUNT_CONFIG, SET_PLAYER_ID, CLEAR_TOKEN, SET_INVITE_LINK, SET_PLAYER_INFO } from '../actions/types';
var initialState = {
  playerId: null,
  casinoIdStatus: '',
  casinoId: '',
  isAccountLinked: false,
  memberLevel: '',
  propertyId: '',
  isDevUser: false,
  aff_id: null,
  KYCInfo: {},
  lastTimeRated: null,
  lastTimeAdBlockerSeen: null,
  gamesOpenedAmount: 0,
  inviteLink: null
};
export var playerInfoReducer = function playerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_PLAYER_INFO:
      {
        return _objectSpread(_objectSpread({}, state), action.payload);
      }
    case SET_PLAYER_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        playerId: action.payload
      });
    case CLEAR_TOKEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        playerId: null
      });
    case SET_CASINO_ID_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        casinoIdStatus: action.payload
      });
    case SET_CASINO_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        casinoId: action.payload
      });
    case SET_KYC_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isKYCDone: action.payload.isKYCDone,
        KYCResult: action.payload.KYCResult,
        KYCInfo: action.payload.KYCInfo
      });
    case SET_PROPERTY_NAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        propertyName: action.payload
      });
    case SET_PROPERTY_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        propertyId: action.payload
      });
    case SET_SOUND_SETTINGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        soundEffects: action.payload.soundEffects,
        music: action.payload.music
      });
    case IS_ACCOUNT_LINKED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAccountLinked: action.payload
      });
    case SET_CURRENT_MEMBER_LEVEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        memberLevel: action.payload
      });
    case SET_IS_DEV_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        isDevUser: action.payload
      });
    case SET_AFF_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        aff_id: action.payload
      });
    case SET_RATING_POPUP_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastTimeRated: action.payload
      });
    case SET_AD_BLOCKER_POPUP_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        lastTimeAdBlockerSeen: action.payload
      });
    case SET_GAMES_OPENED_AMOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        gamesOpenedAmount: action.payload
      });
    case SET_APPSFLYER_GAMES_OPENED_AMOUNT_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        appsflyerGamesOpenedAmountConfig: action.payload
      });
    case SET_INVITE_LINK:
      return _objectSpread(_objectSpread({}, state), {}, {
        inviteLink: action.payload
      });
    default:
      return state;
  }
};
export default playerInfoReducer;